import styled from 'styled-components';

const Wrapper = styled.div`
  width:100%;
  height:100%;
  display:flex;
  position:relative;
  background-color:#1f1f1f;
`

export default Wrapper;